import { render } from "./Toggle.vue?vue&type=template&id=65a81952"
import script from "./Toggle.vue?vue&type=script&lang=ts"
export * from "./Toggle.vue?vue&type=script&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=65a81952&lang=css"
script.render = render

export default script